import React from 'react';
import style from './TradePlanTitleWrapper.module.css';
import PropTypes from 'prop-types';

function TradePlanTitleWrapper({ title, children, rightSplit }) {
  return (
    <div
      className={style.outerWrapper}
      style={{ marginLeft: rightSplit ? '2%' : '5%' }}
    >
      <p className={style.title}>{title}</p>
      {children}
    </div>
  );
}

TradePlanTitleWrapper.propTypes = {
  title: PropTypes.string.isRequired,
  children: PropTypes.any,
  rightSplit: PropTypes.bool,
};
export default TradePlanTitleWrapper;
